import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';

// import { BackendApiService } from '../../../services/backend-api.service';
@Component({
  selector: 'app-manager-assets',
  templateUrl: './manager-assets.component.html',
  styleUrls: ['./manager-assets.component.scss']
})
export class ManagerAssetsComponent implements OnInit {
  pid: boolean;
  showList: boolean;
  emptyMsg: boolean;
  checked = false;
  clientList = [
    {
      id: 12,
      assets_name: 'Asset name',
      mac_address: '168:36:348567:34',
      used_license: 5,
      checked: false,
      total_license: 20,
      image: 'https://4.imimg.com/data4/GE/JJ/MY-1011238/food-bag-making-machine-500x500.jpg'
    }
  ]

  breadcrumbsArray: any = [
    "manager-client-list",
    "manager-users-site-group",
    "manager-assets"
  ];

  public selectValueArr = [];

  constructor(public router: Router, private activeRoute: ActivatedRoute, public dialog: MatDialog) {
    this.clientList;
    activeRoute.queryParams.subscribe(params => {
      this.pid = params['pid'];
      if (this.pid) {
        this.showList = true;
        this.emptyMsg = false;
      } else {
        this.showList = false;
        this.emptyMsg = true;
      }
    });
  }

  viewAsset() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: "clientAssetsDailog",
      }
    });
  }


  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  selectListItem(index: number, userid: number) {
    // if (this.clientList.length !== 0) {
    //   for (var i = 0; i < this.clientList.length; i++) {
    //     if (this.clientList[i].id === userid) {
    //       this.clientList[i].checked = true;
    //     }
    //   }
    // }

    if (this.selectValueArr.length == 0) {
      this.selectValueArr.push(userid);
      for (var i = 0; i < this.clientList.length; i++) {
        if (this.clientList[i].id === userid) {
          this.clientList[i].checked = true;
        }
      }
    } else {
      for (var i = 0; i < this.selectValueArr.length; i++) {
        if (this.selectValueArr[i] === userid) {
          this.selectValueArr.splice(i, 1);
          for (var i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].id === userid) {
              this.clientList[i].checked = false;
            }
          }
        } else {
          this.selectValueArr.push(userid);
          for (var i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].id === userid) {
              this.clientList[i].checked = true;
            }
          }
        }
      }
    }
  }

  ngOnInit() { }

  async addAssets() {
    this.router.navigate(['/manager-add-assets']);
  }

  editAssets() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pid: true,
        pageRef: 'client-assets'
      }
    };
    this.router.navigate(['/clients-add-assets'], navigationExtras);
  }


  // showLicense(): void {
  //   const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
  //     width: '650px',
  //     data: {
  //       type: "adminLicense",
  //     }
  //   });
  // }
}
